import React from 'react';

function lazyIcon(path: string) {
  return React.lazy(() => import(`${path}`));
}

export const ElectronicsIcon = lazyIcon("./Electronics/ic_electronics");
export const SmartPhonesIcon = lazyIcon("./SmartPhones/ic_smartphones");
export const SmartWatchesIcon = lazyIcon("./SmartWatches/ic_smartwatches");
export const TabletsIcon = lazyIcon("./Tablets/ic_tablets");
export const RightArrowIcon = lazyIcon("./RightArrowIcon/right_arrow");
export const QuestionIcon = lazyIcon("./QuestionIcon/question_icon");
export const CloseIcon = lazyIcon("./CloseIcon/close_icon");
export const InfoIcon = lazyIcon("./InfoIcon/info");
export const LeftArrowIcon = lazyIcon("./LeftArrowIcon/left_arrow");
export const TripleUpArrowIcon = lazyIcon("./TripleUpArrowIcon/triple_uparrow");
export const DoubleUpArrowIcon = lazyIcon("./DoubleUpArrowIcon/double_uparrow");
export const UpArrowIcon = lazyIcon("./UpArrowIcon/uparrow");
export const PlusIcon = lazyIcon("./PlusIcon/plus_icon");
export const PlusIconWithBg = lazyIcon("./PlusIconWithBg/plus_iconwithbg");
export const StoreIcon = lazyIcon("./StoreIcon/store_icon");
export const PinIcon = lazyIcon("./PinIcon/pin_icon");
export const FileIcon = lazyIcon("./FileIcon/file_icon");
export const AttheRateIcon = lazyIcon("./AttheRateIcon/attherate_icon");
export const EmailVerifiedIcon = lazyIcon("./EmailVerifiedIcon/emailverified_con");
export const SearchIcon = lazyIcon("./SearchIcon/search_icon");
export const DownArrowIcon = lazyIcon("./DownArrowIcon/downarrow_icon");
export const UpArrowIconDropdown = lazyIcon("./UpArrowIconDropdown/uparrow_icondropdown");
export const NavigationIcon = lazyIcon("./NavigationIcon/navigation");
export const BrowseStoreIcon = lazyIcon("./BrowseStoresIcon/browsestore_icon");
export const ErrorInfoIcon = lazyIcon("./ErrorInfoIcon/error_infoicon");
export const ErrorInfoYellowIcon = lazyIcon("./ErrorInfoYellowIcon/error_info_yellow_icon");
export const ErrorWarningIcon = lazyIcon("./ErrorWarningIcon/error_warning_icon");
export const ErrorInfoIconDark = lazyIcon("./ErrorInfoIconDark/error_infoicondark");
export const TickIcon = lazyIcon("./TickIcon/tick_icon");
export const UpArrowCardIcon = lazyIcon("./UpArrowCardIcon/uparrowcard_icon");
export const DownArrowCardIcon = lazyIcon("./DownArrowCardIcon/downarrowcard_icon");
export const MailIcon = lazyIcon("./MailIcon/mail_icon");
export const LaptopIcon = lazyIcon("./LaptopIcon/laptop");
export const LedTvIcon = lazyIcon("./LedTvIcon/ledtvicon");
export const PortableSpeakersIcon = lazyIcon("./PortableSpeakersIcon/portable_speakers_icon");
export const DesktopsIcon = lazyIcon("./DesktopsIcon/desktops_icon");
export const VideoGameSystemsIcon = lazyIcon("./VideoGameSystemsIcon/videogamesystems");
export const HeadphonesIcon = lazyIcon("./HeadphonesIcon/headphones_icon");
export const EarbudsIcon = lazyIcon("./EarbudsIcon/earbuds_icon");
export const VideoGameConsolesIcon = lazyIcon("./VideoGameConsolesIcon/ic_videogameconsoles");
export const VideoGameControllersIcon = lazyIcon("./VideoGameControllersIcon/video_game_controllers_icon");
export const CarWoofersIcon = lazyIcon("./CarWoofersIcon/carwoofers_icon");
export const VRDevicesIcon = lazyIcon("./VRDevicesIcon/vrdevices_icon");
export const GoldIcon = lazyIcon("./GoldIcon/gold_icon");
export const SilverIcon = lazyIcon("./SilverIcon/silver_icon");
export const PlatinumIcon = lazyIcon("./PlatinumIcon/platinum_icon");
export const JewelryIcon = lazyIcon("./JewelryIcon/jewelry_icon");
export const ToolsIcon = lazyIcon("./ToolsIcon/ic_tools");
export const ToolsDrillsIcon = lazyIcon("./ToolsDrillsIcon/ic_tools_drills");
export const ToolsSawsIcon = lazyIcon("./ToolsSawsIcon/ic_tools_saws");
export const ToolsWrenchesIcon = lazyIcon("./ToolsWrenchesIcon/ic_tools_wrenches");
export const ToolsGrindersIcon = lazyIcon("./ToolsGrindersIcon/ic_tools_grinders");
export const ToolsGardenIcon = lazyIcon("./ToolsGardenIcon/ic_tools_garden");
export const ToolsChainsawsIcon = lazyIcon("./ToolsChainsawsIcon/ic_tools_chainsaws");
export const ToolsLeafBlowersIcon = lazyIcon("./ToolsLeafBlowersIcon/ic_tools_leaf_blowers");
export const ToolsPressureWashersIcon = lazyIcon("./ToolsPressureWashersIcon/ic_tools_pressure_washers");
export const ToolsLawnMowersIcon = lazyIcon("./ToolsLawnMowersIcon/ic_tools_lawn_mowers");
export const ToolsCordedIcon = lazyIcon("./ToolsCordedIcon/ic_tools_corded");
export const ToolsCordlessIcon = lazyIcon("./ToolsCordlessIcon/ic_tools_cordless");
export const ToolsGasIcon = lazyIcon("./ToolsGasIcon/ic_tools_gas");
export const ToolsPneumaticIcon = lazyIcon("./ToolsPneumaticIcon/ic_tools_pneumatic");
export const CheckmarkIcon = lazyIcon("./CheckmarkIcon/checkmark_icon");
export const YesIcon = lazyIcon("./YesIcon/yes_icon");
export const NoIcon = lazyIcon("./NoIcon/no_icon");